module.exports = __webpack_public_path__ + "img/7_03.ca1d208b.jpg";